const dataAttributes = (attributes: Record<string, string>) => ({ ...Object.entries(attributes).reduce((acc, [key, value]) => ({ ...acc, [`data-${key}`]: value }), {}) });

export default dataAttributes;
